import { ActionCreator } from 'typescript-fsa';
import { SubmitHandler } from 'react-hook-form';
import { useDispatch } from '@cbridge-utils/react-redux';
import { interpolateErrorParams } from '@cbridge-utils/formatters';
import { IResolverMeta } from '@cbridge-utils/redux-observable';

export const useAsyncSubmitHandler = <Payload, TData = Payload>(
  actionCreator: ActionCreator<Payload>,
  transform?: (data: TData) => Payload,
  onError?: IResolverMeta['reject'],
): SubmitHandler<TData> => {
  const dispatch = useDispatch();

  const toPayload = (data: TData): Payload => {
    return transform?.(data) ?? data as unknown as Payload;
  };

  return async (data: TData) => {
    return new Promise<void>((resolve, rejectPromise) => {
      const reject: IResolverMeta['reject'] = (code?: string, message?: string, params?: { key: string }) => {
        const resolvedMessage = message ? interpolateErrorParams(message, params) : message;
        const isHandled = onError?.(code, resolvedMessage, params);
        rejectPromise(resolvedMessage ?? code);
        return isHandled;
      };

      try {
        dispatch(actionCreator(toPayload(data), { resolve, reject }));
      } catch (error) {
        reject(error);
      }
    });
  };
};
